import { TableModelObject } from "./TableModelObject";
import { ColumnFilterType } from "./ColumnFilterType";
import { IndexType } from "./IndexType";
import { ColDef } from "ag-grid-community";

export interface BfxColDef extends ColDef {
  /* must be updated at same time as BfxColDef.hide. shouldn't exist */
  visible?: boolean;
  omitFromPicker?: boolean;
  position?: number;
  embeddedModePosition?: number;
  isEmbeddedColumnPriority?: boolean;
  isPriority?: boolean;
  isPrimary?: boolean;
  visibleInEmbeddedMode?: boolean;
  disableInPicker?: boolean;
  lockPriority?: boolean;
  alias?: Array<string>;
  showTooltip?: boolean;
  hasSearchKey?: boolean;
  searchKey?: string;
  hasSortKey?: boolean;
  /** If defined, ensure the indexType supports the additional column name */
  sortKey?: string;
  filterKey?: string;
  columnFilterType?: ColumnFilterType;
  columnFilterData?: any;
  fixedIndexRows?: Array<any>;
  indexType?: IndexType;
  data?: any;
  colSelectorName?: string;
  skipExport?: boolean;
  getFilterValue?: (dataEntity: any) => any;
}

export class TableDefinition {
  public columns: Array<BfxColDef> = [];
  public columnIndexMap: Map<string, number> = new Map<string, number>();
  private modelObject: TableModelObject | null = null;
  public defaultSortKey: number | null = null;
  public defaultSortDir: string | null = "desc";
  public overwriteKey: string = null; // used for risk view in client orders
  public benchmarkTableDefinition: boolean = false;
  public algoTableDefinition: boolean = false;
  public clientTradeTableDefinition: boolean = false;
  public riskTradeTableDefinition: boolean = false;

  constructor(
    public primaryKey: string,
    public primarySortKey: string, //    rowDefinition: RowDefinition
  ) {}

  public setOverwriteKey(overwriteKey: string): void {
    if (typeof overwriteKey === "string" && overwriteKey.length > 0) {
      this.overwriteKey = overwriteKey;
    }
  }

  public getOverwriteKey(): string {
    return this.overwriteKey;
  }

  public hasOverwriteKey(): boolean {
    return this.overwriteKey != null;
  }

  public addColumn(column: BfxColDef): void {
    if (this.columnIndexMap.has(column.field)) {
      // columns must be unique
      throw new Error("Column Names must not be duplicates[" + column.field + "]");
    }

    this.columnIndexMap.set(column.field, this.columns.length);
    this.columns.push(column);

    // invalidate cached modelObject (only regen on demand)
    this.modelObject = null;
  }

  public getColumnDefinition(data: string): BfxColDef | null {
    if (this.columnIndexMap.has(data)) {
      let columnIndex: number = this.columnIndexMap.get(data);
      return this.columns[columnIndex];
    }

    return null;
  }

  public removeColumnDefinition(data: string): BfxColDef | null {
    let columnDef = null;

    if (this.columnIndexMap.has(data)) {
      let columnIndex: number = this.columnIndexMap.get(data);
      columnDef = this.columns[columnIndex];
      this.columnIndexMap.delete(data);
      this.columns.splice(columnIndex, 1);

      this.columnIndexMap.clear();
      this.columns.forEach((c, index) => this.columnIndexMap.set(c.field, index));
    }

    return columnDef;
  }

  public getModelObject(_: BfxColDef[] | null = null): any {
    return {};
  }

  public getDefaultSort(): any {
    if (this.defaultSortKey && this.defaultSortDir) {
      return [[this.defaultSortKey, this.defaultSortDir]];
    } else {
      const primaryKeyIndex = this.columnIndexMap.get(this.primaryKey);

      return [[primaryKeyIndex, "desc"]];
    }
  }

  public setDefaultSort(key: number, dir: string) {
    if (key && dir) {
      this.defaultSortKey = key;
      this.defaultSortDir = dir;
    }
  }
}
